import { useState, useEffect } from "react";
import Tippy from "@tippyjs/react";
import ChannelTooltip from "../channelTooltip/ChannelTooltip";
import { HandySvg } from "handy-svg";
import { Link } from "react-router-dom";
import iconHeart from "../../assets/icons/svg-sprite/heart.svg";
import { tv, favorites } from "../../lib/api/api";

const ChannelHeader = ({ id, favoritesTV, tariffs }) => {
  const [info, setInfo] = useState({});
  const [media, setMedia] = useState({});

  useEffect(() => {
    tv.tvChannels()
      .then((res) => {
        res.channels.forEach((item) => {
          if (item.id === id) {
            setInfo(item);
            setMedia(item.media.default);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <Tippy
        content={<ChannelTooltip channel_id={id} tariffs={tariffs} />}
        arrow={true}
        interactive={true}
        className="my-tooltip"
        placement="right"
        popperOptions={{
          modifiers: [
            {
              name: "flip",
              options: {
                fallbackPlacements: ["left"],
              },
            },
          ],
        }}
      >
        <div className="tv-program__channel-header">
          <Link
            className="tv-program__channel-logo"
            to={`//telekarta.tv/tvprogram/channels/${info.url}`}
          >
            <img src={media.url} width="40" height="40" alt={info.name} />
          </Link>
          <Link
            className="tv-program__channel-name"
            to={`//telekarta.tv/tvprogram/channels/${info.url}`}
          >
            {info.name}
          </Link>
          <div className="tv-program__channel-options">
            <button
              id={`channel-${info.id}-favorites`}
              className={
                "tv-program__channel-like tv-program__channel-option bttn" +
                (favoritesTV.filter(
                  (item) => item.type === 1 && item.channel_id === info.id
                ).length > 0
                  ? " tv-program__channel--liked"
                  : "")
              }
              type="button"
              onClick={() => {
                const TYPE = "channels";
                const heart = document.getElementById(
                  `channel-${info.id}-favorites`
                );
                if (info.id) {
                  if (heart.classList.contains("tv-program__channel--liked")) {
                    const ID = favoritesTV.filter(
                      (item) => item.channel_id === info.id
                    )[0].id;
                    favorites
                      .removeFromFavorites(TYPE, ID)
                      .then((res) => {
                        if (res.error) {
                          console.log(res);
                        } else {
                          heart.classList.remove("tv-program__channel--liked");
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  } else {
                    favorites
                      .addToFavorites(TYPE, info.id)
                      .then((res) => {
                        if (res.error) {
                          console.log(res);
                        } else {
                          heart.classList.add("tv-program__channel--liked");
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }
                }
              }}
            >
              <HandySvg
                className="svg-icon"
                src={iconHeart}
                width="23"
                height="21"
              />
            </button>
          </div>
        </div>
      </Tippy>
    </>
  );
};

export default ChannelHeader;
